import { Alert, AlertTitle, Stack, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface WidgetPresetOption {
  label: string;
  value: string;
}

export interface WidgetPresetOptionsProps {
  options: WidgetPresetOption[];
  setSelectedOption: (option: string) => void;
}

export default function WidgetPresetOptions(props: WidgetPresetOptionsProps): JSX.Element {
  const { i18n } = useTranslation();

  return (
    <Alert
      severity="info"
      sx={{ mt: 2, mb: 2, pb: 0, pt: 0 }}
      variant="outlined"
    >
      <AlertTitle>{i18n.t("widgets.settings.quick-presets")}</AlertTitle>
      <Stack
        direction="row"
        sx={{
          gap: 1,
          flexWrap: "wrap",
          ml: 0,
          mb: 0
        }}>
        {props.options.map((option) => (
          <Button
            key={option.value}
            variant="outlined"
            size="small"
            onClick={() => props.setSelectedOption(option.value)}
            sx={{ mr: 1 }}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
    </Alert>
  );
}